import React, { FunctionComponent } from 'react';

import { ILandingPageLink } from '@/pageGeneration/services/LandingPageService';
import styles from '@/components/landingPages/SuggestedAirportsSection.module.scss';
import DesignText from '@/components/typography/DesignText';

import LinkColumns from '@/components/landingPages/LinkColumns';
import Row from '../layout/Row';
import Col from '../layout/Col';

interface IProps {
  title: string;
  links: ILandingPageLink[];
}

const LinksSection: FunctionComponent<IProps> = ({ title, links }) => (
  <div className={styles.container} data-testid={`${title}LinksSection`}>
    <Row>
      <Col span={24}>
        <DesignText size="large" color="primary" strong>
          {title}
        </DesignText>
      </Col>
    </Row>
    <Row>
      <LinkColumns links={links} />
    </Row>
  </div>
);

export default LinksSection;
